module.exports = __webpack_public_path__ + "static/media/logobackground.6d208220.jfif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logobackground.jfif
// module id = 666
// module chunks = 0